import * as React from 'react';

export default function LoadingBlock({
  label = 'Please wait — fetching your data…',
  className = '',
}) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center gap-3 px-6 py-10 text-center ${className}`}
    >
      <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#1b3b5f]" />
      <p className="max-w-xs text-sm text-gray-500">{label}</p>
    </div>
  );
}
